export const sizeOptions = {
  small: {
    size: "small",
    indicator: "S",
    buttonLabel: "Small",
  },
  medium: {
    size: "medium",
    indicator: "M",
    buttonLabel: "Medium",
  },
  large: {
    size: "large",
    indicator: "L",
    buttonLabel: "Large",
  },
  extraLarge: {
    size: "extra large",
    indicator: "XL",
    buttonLabel: "Extra large",
  },
};

export type SizeOptionKey = keyof typeof sizeOptions;
